import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppConfig} from '../app.config';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PomodoroService {
  private pomodoroUrl = this.config.baseUrl;
  constructor(private http: HttpClient,
              private config: AppConfig) { }
  createPomodoro(pomodoro): Observable<any>{
    return this.http.post(this.pomodoroUrl + '', pomodoro).pipe(map((response: Response) => {
    return response;
    }));
  }
  getPomodoroDetails(): Observable<any>{
    return this.http.get(this.pomodoroUrl + '', {
      headers: {
        Content_Language: localStorage.getItem('trans')
      }
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  getListOfUsersPomodoros(): Observable<any>{
    return this.http.get(this.pomodoroUrl + '/Pomodoro', {
      headers: {
        Content_Language: localStorage.getItem('trans')
      }
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
}
